/**
 * Installable PWA (ADR-037): registers the app's /sw.js so Android offers "Install app". The
 * worker never caches app code (it only shows an offline page when a navigation fails), so a
 * deploy is picked up on the next load. Skipped in dev and tests, where Vite serves the app.
 */
export function registerServiceWorker(): void {
  if (!import.meta.env.PROD || !('serviceWorker' in navigator)) return;
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {
      // Installability is a nicety: the app works the same without the worker.
    });
  });
}
